import script from "./time-controller.vue?vue&type=script&setup=true&lang=ts"
export * from "./time-controller.vue?vue&type=script&setup=true&lang=ts"

import "./time-controller.vue?vue&type=style&index=0&id=794f3781&lang=scss"

const __exports__ = script;

export default __exports__